import { Component, inject } from '@angular/core';
import { ServiceMasterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ServiceMasterCreateDto,
  ServiceMasterDto,
  ServiceMasterExcelDownloadDto,
  ServiceMasterUpdateDto,
} from '../proxy/controlling/dtos/service-master';
import { SERVICEMASTER_CONFIG, SERVICEMASTER_FIELDS } from './service-master.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-service-master',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ServiceMasterService, ConfirmationService],
  templateUrl: './service-master.html',
  styleUrl: './service-master.scss',
})
export class ServiceMaster extends BaseCrudComponent<
  ServiceMasterDto,
  ServiceMasterCreateDto,
  ServiceMasterUpdateDto,
  ServiceMasterExcelDownloadDto
> {
  service = inject(ServiceMasterService);
  config = SERVICEMASTER_CONFIG;
  fields = SERVICEMASTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: ServiceMasterDto): ServiceMasterUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ServiceMaster';
  }
}
